import { Box, Skeleton, Stack } from '@ethings/ui-toolkit';
import { FC } from 'react';

export const ThingSummarySkeleton: FC = () => (
  <Box
    style={{
      alignItems: 'center',
      columnGap: 24,
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
      rowGap: 8,
    }}
  >
    {Array.from({ length: 3 }, (_, index) => (
      <Stack key={index} alignItems="center" direction="row" spacing={1}>
        <Skeleton height={20} variant="circular" width={20} />
        <Skeleton height={24} variant="text" width={index === 0 ? 150 : 110} />
      </Stack>
    ))}
    <Box />
  </Box>
);

